import { MantineThemeOverride, rem } from '@mantine/core';
import { P1Regular } from 'theme/typography';
import { TABLET_BREAKPOINT } from 'theme/components/utils/tablet';
import { getOverlayHeaderStyles } from 'theme/components/Overlays/overlay-header';

export type ModalTheme = NonNullable<MantineThemeOverride['components']>['Modal'];

export const Modal: ModalTheme = {
  defaultProps: {
    radius: 4,
  },
  styles: (theme) => ({
    ...getOverlayHeaderStyles(theme),
    overlay: {
      opacity: 0.4,
      color: theme.colors.gray[9],
    },
    body: {
      ...P1Regular,
      color: theme.colors.gray[7],
      padding: rem(24),
      [theme.fn.smallerThan(TABLET_BREAKPOINT)]: {
        padding: rem(16),
      },
    },
  }),
};
